import ApiService from "@/core/services/api.service";

// action types
export const FETCH_ADMIN_GIFT_CARDS = "fetchAdminGiftCards";
export const STORE_ADMIN_GIFT_CARDS = "storeAdminGiftCards";

// mutation types
// mutation types
export const SET_GIFT_CARDS_CODES = "setGiftCardsCodes";
export const SET_GIFT_CARDS_PATH = "setGiftCardsPath";
export const SET_ADMIN_GIFT_CARDS = "setAdminGiftCards";
export const SET_ADMIN_GIFT_CARDS_PAGINATION = "setAdminProgramsPagination";

const state = {
  adminGiftCards: [],
  giftCardsCodes: [],
  giftCardsPath: "",
  adminGiftCardsPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  giftCardsTypes: {
    1: "استفاده نشده",
    2: "استفاده شده"
  }
};

const getters = {
  adminGiftCards(state) {
    return state.adminGiftCards;
  },
  giftCardsCodes(state) {
    return state.giftCardsCodes;
  },
  giftCardsPath(state) {
    return state.giftCardsPath;
  },
  adminGiftCardsPagination(state) {
    return state.adminGiftCardsPagination;
  },
  giftCardsTypes(state) {
    return state.giftCardsTypes;
  }
};

const actions = {
  [FETCH_ADMIN_GIFT_CARDS](context, name = null) {
    let params = {
      page: context.state.adminGiftCardsPagination.currentPage
    };
    if (name) {
      params.name = name;
    }
    return new Promise((resolve, reject) => {
      ApiService.query("admin/gift-cards", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_GIFT_CARDS, data.data);
          context.commit(SET_ADMIN_GIFT_CARDS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_ADMIN_GIFT_CARDS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("admin/gift-cards", payload, {}, false)
        .then(({ data }) => {
          context.commit(SET_GIFT_CARDS_CODES, data.codes);
          context.commit(SET_GIFT_CARDS_PATH, data.path);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_GIFT_CARDS_CODES](state, giftCardsCodes) {
    state.giftCardsCodes = giftCardsCodes;
  },
  [SET_GIFT_CARDS_PATH](state, giftCardsPath) {
    state.giftCardsPath = giftCardsPath;
  },
  [SET_ADMIN_GIFT_CARDS](state, adminGiftCards) {
    state.adminGiftCards = adminGiftCards;
  },
  [SET_ADMIN_GIFT_CARDS_PAGINATION](state, data) {
    state.adminGiftCardsPagination = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
